import * as React from 'react';
const SvgY = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "m20.366 3.7-7.294 10.077v7.151a1.072 1.072 0 0 1-2.143 0v-7.151L3.633 3.7a1.07 1.07 0 1 1 1.735-1.257L12 11.603l6.634-9.16a1.073 1.073 0 0 1 1.495-.24c.478.348.585 1.018.237 1.497Z", fill: "currentColor" })));
export default SvgY;
